import React from "react";
import { Hourglass, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function WaitlistedBanner() {
    const { user } = useAuth();
    if (!user || user.status !== "waitlisted") return null;
    return (
        <div
            className="nl-card mt-2 mb-4 flex items-start gap-3"
            style={{ background: "#F6ECE3" }}
            data-testid="waitlisted-banner"
        >
            <Hourglass className="w-5 h-5 mt-0.5 shrink-0" style={{ color: "#C47A55" }} />
            <div className="min-w-0">
                <p className="font-serif-editorial text-xl text-[#1A3626]">
                    You're on the waitlist
                </p>
                <p className="text-sm text-[#4A5A4E] mt-1">
                    Your account is awaiting admin approval. You can update your profile and
                    health info now — scanning unlocks the moment an admin allowlists you.
                </p>
                <a
                    href="mailto:iq.ai.solutions@gmail.com?subject=NutriLens%20access%20request"
                    className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-[#3B824E] hover:underline"
                >
                    <Mail className="w-4 h-4" /> Request access
                </a>
            </div>
        </div>
    );
}
